export default __webpack_public_path__ + "static/media/timer.dd5cf5a7.png";